import { useState, useEffect } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import './Categories.css';
import api from '../../utils/api';

export default function CategoryList() {
  const { type } = useParams();
  const [searchParams] = useSearchParams();
  const filter = searchParams.get('filter') || '';
  const navigate = useNavigate();
  const [search, setSearch] = useState(filter);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const title = type === 'professional' ? 'Professional Services' : 'Popular Categories';

  useEffect(() => {
    api.get('/api/categories/all').then(res => {
      const data = res.data.data;
      const cats = type === 'professional' ? data.professional.categories : data.business.categories;
      setCategories(cats);
    }).finally(() => setLoading(false));
  }, [type]);

  const filtered = categories.filter(c => c.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="categories-page">
      <div className="container">
        <div className="cat-top-row">
          <h1 className="cat-page-title">{title}</h1>
          <div className="cat-search">
            <span className="cat-search-icon">🔍</span>
            <input
              placeholder="Search categories..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            {search && (
              <button className="cat-search-clear" onClick={() => setSearch('')}>✕</button>
            )}
          </div>
        </div>

        {loading ? (
          <div className="empty-state"><span>⏳</span><p>Loading...</p></div>
        ) : (
          <div className="cat-grid">
            {filtered.map((cat, i) => (
              <div key={i} className="cat-card" onClick={() => {
                if (cat.subCategories?.length) navigate(`/category/${encodeURIComponent(cat.name)}`);
                else navigate(`/businesses?category=${cat.name}`);
              }}>
                <div className="cat-card-icon">{cat.icon}</div>
                <p>{cat.name}</p>
              </div>
            ))}
          </div>
        )}

        {!loading && filtered.length === 0 && (
          <div className="empty-state">
            <span>🔍</span>
            <p>No categories found for "{search}"</p>
          </div>
        )}
      </div>
    </div>
  );
}
